

interface StatusWithMarkerProps {
  textColour: string;
  markerColour: string;
  children: string;
  id?: string;
  dataTag?: string;
}

const StatusWithMarker = ({
  textColour,
  markerColour,
  children,
  id,
  dataTag,
}: StatusWithMarkerProps) => (
  <div className="flex flex-row gap-3 w-full">
    <span
      data-tag={dataTag}
      className={`h-2 w-2 border-solid ${markerColour} rounded-full self-center`}
    />
    <small id={id} data-tag={dataTag} className={`break-keep text-wrap ${textColour}`}>
      {children}
    </small>
  </div>
);

export default StatusWithMarker;
